import {Cancel, CloudUpload} from '@mui/icons-material';
import {IconButton, Paper, Typography} from '@mui/material';
import {useDropzone} from 'react-dropzone';
import {IUploadFileType} from '../../../../components/styles/UploadFiles';
import {IDemoScriptStateProp} from '../../../../dto/demoStingerFulfilment.dto';

type Props = {
  id: number;
  setMessage: React.Dispatch<React.SetStateAction<IDemoScriptStateProp[]>>;
  message: IDemoScriptStateProp;
};
const DemoStingerFileUpload = ({id, setMessage, message}: Props) => {
  const onDrop = (files: IUploadFileType[]) => {
    if (files.length > 0) {
      const file = files[0];
      if (file) {
        file.url = URL.createObjectURL(file);
        setMessage(prevState =>
          prevState.map(stateItem =>
            stateItem.id === id ? {...stateItem, file} : stateItem,
          ),
        );
      }
    }
  };
  const {getRootProps, getInputProps} = useDropzone({
    accept: {
      'audio/mpeg': [],
    },
    onDrop,
  });
  const handleDelete = () => {
    setMessage(prevState =>
      prevState.map(stateItem =>
        stateItem.id === id ? {...stateItem, file: null} : stateItem,
      ),
    );
  };
  return (
    <Paper
      sx={{border: '1px solid #c3c3c330'}}
      elevation={0}
      {...getRootProps()}
      className='flex-column justify-center items-center p-3 text-center'>
      {message.file ? (
        <>
          <IconButton
            title='Delete All'
            aria-label='delete'
            color='error'
            onClick={handleDelete}>
            <Cancel />
          </IconButton>
          <Typography>{message.file.name}</Typography>
        </>
      ) : (
        <>
          <input {...getInputProps()} />
          <CloudUpload sx={{fontSize: 48}} />
          <Typography variant='subtitle1'>
            Drag & drop a file here or click to select a file
          </Typography>
        </>
      )}
    </Paper>
  );
};

export default DemoStingerFileUpload;
